import type { MinigameStep } from '../engine/stepEngine';

export interface MinigameRegistryEntry {
  registryId: string;
  templateId: number;
  name: string;
  entryPath: string;
}

const MINIGAME_REGISTRY: MinigameRegistryEntry[] = [
  { registryId: 'minigame_investigation_01', templateId: 1, name: '証拠並べ', entryPath: '/minigames/01/index.html' },
  { registryId: 'minigame_fingerprint_02', templateId: 2, name: '指紋採取', entryPath: '/minigames/02/index.html' },
  { registryId: 'minigame_cipher_03', templateId: 3, name: '暗号解読', entryPath: '/minigames/03/index.html' },
  { registryId: 'minigame_timeline_04', templateId: 4, name: '時系列並べ', entryPath: '/minigames/04/index.html' },
  { registryId: 'minigame_evidence_05', templateId: 5, name: '関連付けボード', entryPath: '/minigames/05/index.html' },
  { registryId: 'minigame_comparison_06', templateId: 6, name: '間違い探し', entryPath: '/minigames/06/index.html' },
  { registryId: 'minigame_contradiction_07', templateId: 7, name: '矛盾指摘', entryPath: '/minigames/07/index.html' },
  { registryId: 'minigame_chase_08', templateId: 8, name: '追跡', entryPath: '/minigames/08/index.html' },
  { registryId: 'minigame_quickcipher_09', templateId: 9, name: '高速暗号', entryPath: '/minigames/09/index.html' },
  { registryId: 'minigame_investigation_10', templateId: 10, name: '捜査（調査）', entryPath: '/minigames/10/index.html' },
  { registryId: 'minigame_contradiction_11', templateId: 11, name: '矛盾突き付け', entryPath: '/minigames/11/index.html' },
  { registryId: 'minigame_mr_liquid_19', templateId: 19, name: 'Mr.リキッド能力発動', entryPath: '/minigames/19/index.html' },
  { registryId: 'minigame_soma_calling_fire_20', templateId: 20, name: '杣川の呼び火', entryPath: '/minigames/20/index.html' },

  // テスト専用：Reactテンプレ（minigameComponents）に存在しない registryId を用意し、
  // iframe + postMessage 経路のE2E確認に使う
  { registryId: 'minigame_test_iframe_99', templateId: 3, name: 'E2E PostMessage Test', entryPath: '/minigames/_shared/postmessage-e2e.html' }
];

export function resolveRegistryEntry(registryId?: string, templateId?: number): MinigameRegistryEntry | null {
  if (!registryId && !templateId) {
    return null;
  }
  if (registryId) {
    const match = MINIGAME_REGISTRY.find((entry) => entry.registryId === registryId);
    if (match) {
      return match;
    }
  }
  if (templateId) {
    const match = MINIGAME_REGISTRY.find((entry) => entry.templateId === templateId);
    if (match) {
      return match;
    }
  }
  return null;
}

export function resolveMinigameEntry(step: MinigameStep): { entryUrl: string; registry?: MinigameRegistryEntry } | null {
  const entry = resolveRegistryEntry(step.registryId, step.templateId);
  // NOTE: 開発中はポートが揺れやすいので、同一originを優先してCORS/Origin不一致を避ける
  const base =
    import.meta.env.DEV
      ? (typeof window !== 'undefined' ? window.location.origin : 'http://localhost')
      : (import.meta.env.VITE_MINIGAME_BASE_URL || (typeof window !== 'undefined' ? window.location.origin : 'http://localhost'));
  if (!entry) {
    return null;
  }
  const entryUrl = buildAbsoluteUrl(base, entry.entryPath);
  return { entryUrl, registry: entry };
}

function buildAbsoluteUrl(base: string, path: string): string {
  if (/^https?:\/\//i.test(path)) {
    return path;
  }
  const normalizedBase = base.endsWith('/') ? base.slice(0, -1) : base;
  return `${normalizedBase}${path.startsWith('/') ? path : `/${path}`}`;
}
